import { useMemo } from "react";

/**
 * Stabilizes a potentially-referentially-unstable reference to its first observed
 * value, with optional explicit dependencies
 *
 * @param value the value to stabilize
 * @param deps optional list of dependencies
 * @returns the value that was passed to this function on its first render
 * (or, the last render where deps changed, if provided)
 */
export const useStabilized = <T>(value: T, deps?: any[]) =>
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useMemo(() => value, deps ?? []);
